var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('vueVimeoPlayer',{staticClass:"embed-responsive-item",attrs:{"video-id":_vm.videoId,"options":_vm.playerOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }